import React from 'react'
import { useSelector } from 'react-redux';
import { selectSelectedCountryCode } from '../../store/user';
import { Helmet } from 'react-helmet-new';
import SeoData from '../../utils/seo.json';
import NewHelmetLayout from '../../components/general/newHelmetLayout';
import banner from '../../images/banners/MATW_General_2025_DonateThisJumuah_ReceiptBanner.jpg';
import RecurringDonationWidget from '../../components/recurringDonation';
import last10Img from '../../images/ramadan/last-10-nights-text.jpg';

const RecurringDonation = () => {
    const selectedcountryCode = useSelector(selectSelectedCountryCode);
    const seo = SeoData[selectedcountryCode];
    const products = [
        'OPR-GEN-SUP-2023-01-01',
        'MD-AA-2024-02',
        'MKD-MN-001',
        'MD-AA-2024-07',
        'MKD-GEN-MZK-2023-01-123'
    ];
    /* ------------------------------ Start methods ----------------------------- */
    return (
        <NewHelmetLayout hideFooter className="bg-white " childClasses={'pb-0'}>
            {seo &&
                <Helmet>
                    <title>{`${seo['ramadanDaily']['title']}`}</title>
                    <link rel="canonical" href={`${window.location.protocol + '//matwproject.org'}${window.location.pathname}`} />
                    <meta name="description" content={`${seo['ramadanDaily']['description']}`} />
                </Helmet>
            }
            <section className="flex justify-center">
                <img src={banner} alt="Fridays Giving" className="w-full" />
            </section>
            <section className="w-full md:container md:mx-auto py-4 md:py-8 gap-4">
            <div className="w-full">
                    <div className="flex justify-center">
                        <div className="font-brandingBold sm:text-center font-bold text-[#093686] text-2xl sm:text-3xl lg:text-5xl px-4 w-full sm:w-10/12">
                            Jummah Club: Give on the Best Day
                            <br />
                            <span className="text-[#F60362] mr-2">Reap the Best Rewards!</span>
                        </div>
                    </div>
                    <div className="px-4 md:px-6 mt-2 sm:mt-10 leading-5">
                        <div className="text-[#78716C] text-lg text-left font-brandingMedium">
                            Join MATW’s Jummah giving club and align your giving with the most blessed day of the week— Jummah (Friday). Make a habit of giving regularly every Friday, and multiply your rewards while supporting those who need it most.
                            <br />
                            <br />
                            Joining our Jummah giving club means more than just giving regularly. It means reviving a beautiful Sunnah every single week. Friday is the best day in Islam — a day of mercy, blessings, and answered duas. Giving on this day is especially rewarded.
                            <br />
                            <br />
                            When you join our Jummah Giving community, your donation will be automatically processed every Friday, giving you peace of mind that you’re fulfilling this Sunnah consistently, and that your Amanah is being honoured — even when life gets busy.
                            <br />
                            <br />
                            Let’s make every Friday a day of giving and gratitude.
                        </div>
                    </div>
                    <div className="px-4 md:px-6 mt-2 sm:mt-10 leading-5">
                        <div className="text-[#78716C] text-lg text-left font-brandingMedium">
                            <h2 className='font-brandingBold font-bold text-[#093686] text-xl sm:text-2xl lg:text-3xl w-full'>
                                Why Join MATW’s Jummah Giving Club?
                            </h2>
                            <br />
                            Our MATW Jummah Giving club donors are part of a community of compassionate changemakers who give weekly for the sake of Allah. You’ll be part of a powerful Ummah-led movement that’s focused on building a better world, and a better Akhirah.
                            <br />
                            <br />
                            With your support, our MATW team can:
                            <br />
                            <br />
                            <ul className='list-disc pl-2 md:pl-4'>
                                <li>Maintain and expand our orphan centres</li>
                                <li>Respond rapidly to emergencies, providing relief where and when it's needed most</li>
                                <li>Launch livelihood projects to lift families out of poverty</li>
                                <li>Build Sadaqah Jariyah initiatives that transform entire communities</li>
                                <li>Ensure relief delivery under our 100% donation policy</li>
                            </ul>
                            <br />
                            <strong>Your Jummah Donation = Real Impact</strong>
                            <br />
                            <br />
                            <strong>Full Transparency. Maximum Reward.</strong>
                            <br />
                            <br />
                            When you become a Jummah Giver, you’ll receive:
                            <br />
                            <br />
                            <ul className='list-disc pl-2 md:pl-4'>
                                <li>A giving schedule, set to donate automatically on Fridays</li>
                                <li>A bi-annual impact report, showing how your generosity is transforming lives</li>
                                <li>Full Zakat eligibility and tax-deductible receipts</li>
                                <li>The reward of giving on the most blessed day, week after week.</li>
                            </ul>
                            <br />
                            <br />
                            <strong>Ready to Make Every Jummah Count? This is your chance to be part of a movement that gives life, light, and love — every single Friday.</strong>
                            <br />
                            <br />
                            Give Sadaqah on the day Allah has made most beloved.
                            <br />
                            Plant seeds of Sadaqah Jariyah that grow with every Jummah.
                            <br />
                            Support orphans, the poor, and the forgotten — with peace of mind that your giving is consistent and accepted.
                            <br />
                            <br />
                            <strong>Change lives every Friday. Invest in your Akhirah forever.</strong>
                        </div>
                        <img src={last10Img} alt="fridays giving" className="w-full max-w-[500px] my-1 md:my-3" />
                    </div>
                </div>
                <div className="w-full mt-4 md:mt-8">
                    <RecurringDonationWidget productsList={products} />
                </div>
            </section>
        </NewHelmetLayout>
    )
}

export default RecurringDonation